import { Option, SelectInputProps } from "./types/selectInputProps";
import './selectInput.scss';
import { useContext, useEffect, useRef, useState } from "react";
import { AdditionalIcon } from "../additionalIcon/additionalIcon";
import { ReactComponent as ArrowDropUp } from "../../../icons/arrow_drop_up.svg";
import { ReactComponent as ArrowDropDown } from "../../../icons/arrow_drop_down.svg";
import { ReactComponent as Error } from "../../../icons/error.svg";
import Label from "../label/label";
import { labelProps } from "../label/types/labelProps";
import UseDebounce from "../../../helpers/debounce";
import ButtonField from "../../buttonField/buttonField";
import { iconStyle } from "../stylization";
import Tabbar from "../tabbar/tabbar";
import { TipProps } from "../errorTip/types/errorTipProps";
import ErrorTip from "../errorTip/errorTip";
import { ReactComponent as EmergencyHome } from '../../../icons/emergency_home.svg';
import { ReactComponent as cancel } from '../../../icons/cancel.svg';
import { inputStateType, validation } from "../../../helpers/validation/validation";
import Chip from "../chip/chip";
import { ReactComponent as addCircle } from '../../../icons/add_circle.svg';
import { useClickOutside } from "../../../hooks/clickOutsideHook";
import KrFormContext from "../../../contexts/krFormContext";

const SelectInput = (props: SelectInputProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const { fillDate } = useContext(KrFormContext);
    var defaultOption: Option = { name: "", value: "" };
    const [useAlternateOptions, setUseAlternateOptions] = useState(false);
    const [opt, setOpt] = useState(props.options?.filter(op => op.hide !== true)?.slice(0, 100));
    const [selectedOptions, setSelectedOptions] = useState(props.selectedOptions !== undefined && props.selectedOptions.length > 0 ? props.selectedOptions : []);
    const [selectedSingleOption, setSelectedSingleOption] = useState(props.selectedSingleOption !== undefined && props.selectedSingleOption !== null ? props.selectedSingleOption : defaultOption);
    const [selectedSingleOptionColorCode, setSelectedSingleOptionColorCode] = useState(0);
    const [errorCautionDisplay, setErrorCautionDisplay] = useState('none');
    const [pristine, setPristine] = useState(props.pristine);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [ValidIcon, setValidIcon] = useState('none');
    const [inputState, setInputState] = useState('');
    const [errorText, setErrorText] = useState(props.tipText ? props.tipText : props.validationError ?
        validation(props.configValidation, props.selectedOptions?.length !== 0 ? props.selectedOptions?.length : undefined) as string : undefined);
    const [reload, setReload] = useState(false);
    const refocusRef = useRef<HTMLInputElement>(null);

    const wrapperRef = useRef<HTMLDivElement>(null);
    useClickOutside(wrapperRef, () => {
        setIsOpen(false);
    });

    useEffect(() => {
        if (selectedOptions !== undefined && selectedOptions != null && selectedOptions.length > 0) {
            selectedOptions.forEach((seloption) => {
                if (seloption.anothers !== undefined) {
                    if ((seloption.anothers.WAZNY_OD !== undefined && seloption.anothers.WAZNY_OD != null) ||
                        (seloption.anothers.WAZNY_DO !== undefined && seloption.anothers.WAZNY_DO != null)) {
                        setErrorText(validation(props.configValidation, props.selectedOptions?.length !== 0 ? props.selectedOptions?.length : undefined,
                            undefined, undefined, { fillDate: fillDate, fillDateFrom: seloption.anothers.WAZNY_OD, fillDateTo: seloption.anothers.WAZNY_DO }
                        ))
                        showError();
                    }
                }
            })
        }

        if (selectedSingleOption !== undefined && selectedSingleOption.anothers !== undefined) {
            if (selectedSingleOption.anothers.WAZNY_OD !== undefined && selectedSingleOption.anothers.WAZNY_OD != null) {
                setErrorText(validation(props.configValidation, props.selectedOptions?.length !== 0 ? props.selectedOptions?.length : undefined,
                    undefined, undefined, {
                    fillDate: fillDate, fillDateFrom: selectedSingleOption.anothers.WAZNY_OD,
                    fillDateTo: selectedSingleOption.anothers.WAZNY_DO
                }
                ))
                showError();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fillDate])

    useEffect(() => {
        if (props.refocus) {
            refocusRef.current?.focus();
        }
    }, [props.refocus]);

    const selectFieldKeyboardNav = (event: any) => {
        keyboardNavigationOpenDropDown(event);
        keyboardNavigationCloseDropDown(event);
    }

    const keyboardNavigationOpenDropDown = (event: any) => {
        // ArrowDown
        return event.keyCode === 40 && !isOpen && toggleDropdown();
    }

    const keyboardNavigationCloseDropDown = (event: any) => {
        // ArrowUp
        return event.keyCode === 38 && isOpen && toggleDropdown();
    }

    const optionKeyboardNav = (event: any, option: Option) => {
        keyboardNavigationSelectOption(event, option);
        keyboardNavigationCloseDropDown(event);
    }

    const keyboardNavigationSelectOption = (event: any, option: Option) => {
        // Enter   
        return event.keyCode === 13 && handleOptionClick(option);
    }

    const toggleDropdown = () => {
        if (!isOpen) {
            var sliceCount = props.optionsSliceCount ? props.optionsSliceCount : 100;
            if (props.optionsSliceOff) {
                setOpt(props.options?.filter(op => op.hide !== true))
            } else {
                setOpt(props.options?.filter(op => op.hide !== true)?.slice(0, sliceCount));
            }
            if (props.optionsField?.tabbarVisible && props.optionsField.setTabToDefault) props.optionsField.setTabToDefault();
        }
        setIsOpen(!isOpen);
    }

    var tipProps: TipProps = {
        style: {
            display: errorCautionDisplay
        }
    }

    const showError = () => {
        setErrorCautionDisplay('inline-block');
        setInputState(inputStateType.inputError);
    }

    const clearError = () => {
        setErrorCautionDisplay('none');
        setInputState('');
    }

    const showValid = () => {
        setValidIcon('inline-block');
        if (!props.keepPristine && !props.pristine) setInputState(inputStateType.inputValid);
    }

    const clearValid = () => {
        setValidIcon('none');
        setInputState('');
    }

    useEffect(() => {
        if (props.validationError === true) {
            var errorText = validation(props.configValidation, props.selectedOptions?.length !== 0 ? props.selectedOptions?.length : undefined);
            if (errorText) {
                setErrorText(errorText);
                showError();
                setValidIcon('none');
            } else {
                if (selectedOptions !== undefined && selectedOptions != null && selectedOptions.length > 0) {
                    let breakValue = false;
                    selectedOptions.forEach((seloption) => {
                        if (seloption.anothers !== undefined) {
                            if (((seloption.anothers.WAZNY_OD !== undefined && seloption.anothers.WAZNY_OD != null) ||
                                (seloption.anothers.WAZNY_DO !== undefined && seloption.anothers.WAZNY_DO != null)) && !breakValue) {
                                setErrorText(validation(props.configValidation, props.selectedOptions?.length !== 0 ? props.selectedOptions?.length : undefined,
                                    undefined, undefined, { fillDate: fillDate, fillDateFrom: seloption.anothers.WAZNY_OD, fillDateTo: seloption.anothers.WAZNY_DO }
                                ))
                                showError();
                                breakValue = true;
                            }
                        }
                    })
                }
                else if (selectedSingleOption !== undefined && selectedSingleOption.anothers !== undefined) {
                    if (selectedSingleOption.anothers.WAZNY_OD !== undefined && selectedSingleOption.anothers.WAZNY_OD != null) {
                        setErrorText(validation(props.configValidation, props.selectedOptions?.length !== 0 ? props.selectedOptions?.length : undefined,
                            undefined, undefined, {
                            fillDate: fillDate, fillDateFrom: selectedSingleOption.anothers.WAZNY_OD,
                            fillDateTo: selectedSingleOption.anothers.WAZNY_DO
                        }
                        ))
                        showError();
                    }
                    else {
                        clearError();
                        if (!pristine) showValid();
                    }
                }
                else {
                    clearError();
                    if (!pristine) showValid();
                }
            }
        } else {
            clearError();
            if (!pristine) showValid();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.validationError, props.tipText])

    useEffect(() => {
        var opt: Option = { name: "", value: "" }
        setSelectedSingleOption(props.selectedSingleOption !== undefined && props.selectedSingleOption !== null ? props.selectedSingleOption : opt);
        if (props.selectedOptions) setSelectedOptions(props.selectedOptions !== undefined && props.selectedOptions.length > 0 ? props.selectedOptions : []);
        setReload(!reload);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.selectedSingleOption, props.reload, props.selectedOptions]);

    useEffect(() => {
        if (props.optionsField?.isVisible && !props.optionsField.isSelectOpen) {
            setIsOpen(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.optionsField?.isSelectOpen]);

    useEffect(() => {
        if (props.optionsField?.tabbarVisible && isOpen) {
            if (props.optionsField?.tabForAlternateOptions === props.optionsField?.selectedTab) {
                setUseAlternateOptions(true);
                setOpt(props.optionsField?.alternateOptions?.slice(0, 100));
            }
            else {
                setUseAlternateOptions(false);
                setOpt(props.options?.filter(op => op.hide !== true)?.slice(0, 100));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.optionsField?.tabForAlternateOptions, props.optionsField?.selectedTab, props.optionsField?.alternateOptions, isOpen]);

    useEffect(() => {
        if (props.enableClean) {
            setSelectedOptions([]);
            setIsOpen(false);
        }
    }, [props.cleanSelected, props.enableClean]);

    const handleOptionClick = (option: Option) => {
        if (props.hasInputTags) {
            var options = selectedOptions;
            if (props.onlySingleTag) {
                options = [];
                options.push(option);
            }
            else if (props.onlyTwoTags) {
                if (selectedOptions.find((Option) => { return option.value === Option.value }) === undefined && selectedOptions.length < 2) {
                    options.push(option);
                }
            }
            else {
                if (selectedOptions.find((Opt) => { return option.value === Opt.value }) === undefined && !props.onlySingleTag) {
                    if (option.name?.toLocaleLowerCase() === "brak" || option.name?.toLocaleLowerCase() === "brak możliwości obserwacji") {
                        (options = [option])
                    } else {
                        var OptionIndex = selectedOptions.findIndex((value) => { return (value.name?.toLowerCase() === "brak" || value.name?.toLocaleLowerCase() === "brak możliwości obserwacji") });
                        if (OptionIndex > -1) {
                            options.splice(OptionIndex, 1);
                            options.push(option);
                        }
                        else {
                            options.push(option);
                        }
                    }
                }
            }
            setSelectedOptions(options);
            setIsOpen(false);
            if (props.onChange) props.onChange(options)
        }
        else {
            setSelectedSingleOption(option);
            if (props.optionItemDots && props.colorCodesForDots !== undefined) {
                var config = props.colorCodesForDots.filter((element: any) => element.value === option.value);
                setSelectedSingleOptionColorCode(config[0].colorCode);
            }
            setIsOpen(false);
            if (props.onChange) props.onChange(option)
        }
        setOpt(useAlternateOptions ? props.optionsField?.alternateOptions?.slice(0, 100) : props.options?.filter(op => op.hide !== true)?.slice(0, 100));
        checkValidation(option.value);
    };

    const checkValidation = (value: string | number | undefined) => {
        var errorText = validation(props.configValidation, value);
        setPristine(false);
        if (errorText) {
            clearValid();
            setErrorText(errorText);
            showError();
        }
        else {
            if (value || value === 0) {
                clearError();
                showValid();
                setErrorText('');
            }
        }
    }

    const handleAdditionaIcon = () => {
        if (props.disabled) return null;
        if (isOpen) return (<ArrowDropUp onClick={toggleDropdown} />)
        return (<ArrowDropDown onClick={toggleDropdown} />)
    }

    const handleInputChange = (e: any) => {
        if (e.target.value) {
            var optObjects = useAlternateOptions ? props.optionsField?.alternateOptions : props.options?.filter(op => op.hide !== true);
            if (optObjects) {
                optObjects = optObjects?.filter((option) => {
                    return option.name?.toLowerCase().includes(e.target.value.toLowerCase());
                })
                if (!isOpen) {
                    setIsOpen(true);
                }
                setOpt(optObjects);
            }
        } else {
            setOpt(useAlternateOptions ? props.optionsField?.alternateOptions?.slice(0, 100) : props.options?.filter(op => op.hide !== true)?.slice(0, 100))
        }
    }

    const createWithoutInput = () => {
        return (<>
            <input
                tabIndex={getTabIndexByDisableProp()}
                onKeyDown={selectFieldKeyboardNav}
                className={`${props.disabled ? 'is-disabled' : ''}`}
                onClick={toggleDropdown}
                style={colorPerDot(selectedSingleOption, true)}
                aria-disabled={true}
                placeholder={props.placeHolder}
                value={selectedSingleOption.name}
                onChange={() => { }}
                ref={refocusRef}
                onBlur={() => { if (props.setRefocusButton) props.setRefocusButton(false) }}></input>
            {(props.additionalIcon) ? AdditionalIcon(props.additionalIcon, { float: "right" }) : handleAdditionaIcon()}
        </>)
    }

    const createTags = () => {
        if (props.onlySingleTag) {
            return (selectedOptions.length > 0 ? createSingleTag() : null);
        }
        return (selectedOptions.length > 0 ? createMultiTag() : null);
    }

    const createSingleTag = () => {
        return <Chip title={selectedOptions[0].name}
            onlySingleTag={props.onlySingleTag}
            onClose={deleteTag}
            data={selectedOptions[0]}
            enableKeyboardNav={!props.disabled} />
    }

    const createMultiTag = () => {
        return (selectedOptions.map((option: Option) => {
            return <Chip key={option.value} title={option.name}
                onlySingleTag={false}
                onClose={deleteTag}
                data={option}
                enableKeyboardNav={!props.disabled} />
        }))
    }

    const deleteTag = (option: Option) => {
        let options = selectedOptions;
        var index = options.indexOf(option);
        options.splice(index, 1);
        setSelectedOptions([...options]);
        if (options.length === 0) {
            checkValidation(undefined);
        }
        if (props.onChange) props.onChange(options);
    }

    const handleDivMouseDown = (event: any) => {
        event.preventDefault(); // Prevents the input from losing focus
    };

    const getTabIndexByDisableProp = () => {
        return props.disabled ? -1 : 0;
    }

    const createWithInput = () => {
        var isSelected: boolean = selectedOptions.length > 0 || selectedSingleOption.value !== "";
        return (<>
            <div className="AllTags">{createTags()}
                {(!isSelected && props.onlySingleTag) ?
                    <input
                        tabIndex={getTabIndexByDisableProp()}
                        onKeyDown={selectFieldKeyboardNav}
                        placeholder={props.placeHolder}
                        className={`inputStyles ${props.disabled ? 'is-disabled' : ''}`}
                        onChange={UseDebounce(handleInputChange, 500)}
                        ref={refocusRef}
                        onBlur={() => { if (props.setRefocusButton) props.setRefocusButton(false) }}></input>
                    : undefined}
                {!props.onlySingleTag &&
                    <input
                        tabIndex={getTabIndexByDisableProp()}
                        onKeyDown={selectFieldKeyboardNav}
                        placeholder={!isSelected ? props.placeHolder : ""}
                        className={`inputStyles ${props.disabled ? 'is-disabled' : ''}`}
                        onChange={UseDebounce(handleInputChange, 500)}
                        ref={refocusRef}
                        onBlur={() => { if (props.setRefocusButton) props.setRefocusButton(false) }}></input>}
            </div>
            {((props.additionalIcon) ? AdditionalIcon(props.additionalIcon, { float: "right" }) : handleAdditionaIcon())}
        </>);
    }

    const colorPerDot = (item: Option, formatInput: boolean) => {
        var style: React.CSSProperties = formatInput ? { border: "0px", padding: "0px", backgroundColor: "#FAFAFA", cursor: "pointer", width: '100%' } : {};
        if (item.value === '' || props.colorCodesForDots === undefined) {
            return style
        }
        switch (selectedSingleOptionColorCode) {
            case 0: return style
            case 1:
                style.backgroundColor = "#FFF5F5";
                if (!formatInput) style.borderColor = "#F35741";
                return style
            case 2:
                style.backgroundColor = "#FFFDE7";
                if (!formatInput) style.borderColor = "#FBC13C";
                return style
            case 3:
                style.backgroundColor = "#F6F7F0";
                if (!formatInput) style.borderColor = "#96A85F";
                return style
        }

    }

    const getDotStyle = (item: Option) => {
        if (item.value === '' || props.colorCodesForDots === undefined) return "";
        var config = props.colorCodesForDots.filter((element: any) => element.value === item.value);
        var styles = "option-dots ";
        switch (config[0].colorCode) {
            case 0: return styles + "dot-empty"
            case 1: return styles + "dot-red"
            case 2: return styles + "dot-yellow"
            case 3: return styles + "dot-green"
        }
    }

    var labelProps: labelProps = {
        style: {
            marginBottom: '10px',
            display: "inline-block"
        },
        additionalIcon: props.labelAdditionalIcon
    }

    var optionsStyle: React.CSSProperties = {
        maxHeight: isOpen ? '300px' : '0px',
        border: isOpen ? '1px solid #ccc' : '0px'
    }

    var optionsFieldStyle: React.CSSProperties = {
        maxHeight: isOpen ? '430px' : '0px',
        border: isOpen ? '1px solid #ccc' : '0px'
    }

    var optionsHidden: React.CSSProperties = {
        visibility: "hidden"
    }

    var optionsVisible: React.CSSProperties = {
        visibility: "visible"
    }

    const getVisibilityForKeyboardNav = () => {
        return isOpen ? optionsVisible : optionsHidden;
    }

    return (
        <div ref={props.selectRef} style={props.style} className={props.className}>
            {!props.hideLabel && <Label {...labelProps} className='body-txt-medium' labelname={props.label}></Label>}
            <div ref={wrapperRef} className={`wrapper-select-container`}>
                <div onClick={props.setCommentsFilter} className={`custom-select-container`}>
                    <div placeholder={props.placeHolder} style={props.addCommentBtn?.visible ? { ...colorPerDot(selectedSingleOption, false), paddingRight: '57px' } : colorPerDot(selectedSingleOption, false)} className={`${inputState} selected-option ${props.disabled ? 'is-disabled' : ''} ${props.isMarkedForCommentFilter ? 'markedForCommentFilter' : ''}`} onClick={props.hasInputTags ? undefined : toggleDropdown}>
                        {props.hasInputTags ? reload ? createWithInput() : <>{createWithInput()}</> : (reload ? createWithoutInput() : <>{createWithoutInput()}</>)}
                    </div>
                    {!props.optionsField?.isVisible && isOpen && (
                        <ul className="options-list" style={{ ...optionsStyle, ...props.optionsStyle }}>
                            {opt?.map((option: Option, index) => (
                                <li tabIndex={0} onKeyDown={(e) => optionKeyboardNav(e, option)} className={`${props.optionItemDots ? "option-item" : ""}`} key={index} onClick={() => handleOptionClick(option)}
                                    onMouseDown={handleDivMouseDown}>
                                    <div className={`${props.optionItemDots ? `${getDotStyle(option)}` : ""}`}></div>
                                    {option.name}
                                </li>
                            ))}
                        </ul>
                    )}
                    {props.optionsField?.isVisible && (
                        <div className="options-field" style={{ ...optionsFieldStyle, ...props.optionsStyle, ...getVisibilityForKeyboardNav() }}>
                            {props.optionsField.tabbarVisible &&
                                <Tabbar className="options-tabbar" selected={props.optionsField.selectedTab} options={props.optionsField.tabbarOptions} ></Tabbar>
                            }
                            {opt?.length! > 0 &&
                                <ul className="options-ul" style={optionsStyle}>
                                    {opt?.map((option: Option, index) => (
                                        <li tabIndex={0} onKeyDown={(e) => optionKeyboardNav(e, option)} className={`${props.optionItemDots ? "option-item" : ""}`} key={index} onClick={() => handleOptionClick(option)}>
                                            <div className={`${props.optionItemDots ? `${getDotStyle(option)}` : ""}`}></div>
                                            {option.name}
                                        </li>
                                    ))}
                                </ul>
                            }
                            {opt?.length! === 0 &&
                                <div className="option-field-error" style={{ height: isOpen ? '200px' : '0px', borderBottom: isOpen ? '1px solid #ccc' : '0px' }}>
                                    <Error style={iconStyle} />
                                    {props.optionsField.errorMsg}
                                </div>

                            }
                            {props.optionsField.btnVisible &&
                                <div className="select-btn-wrapper">
                                    <ButtonField {...props.optionsField.btnFieldProps} />
                                </div>
                            }
                        </div>
                    )}
                    {props.addCommentBtn?.visible &&
                        <div className={`addCommentBtnWrapper addCommentBtnWrapperRegular ${props.isMarkedForCommentFilter ? "activeAddCommentBtn" : ""}`} onClick={props.addCommentBtn.onClick}>
                            {AdditionalIcon(addCircle)}
                        </div>
                    }
                </div>
            </div>
            <ErrorTip props={tipProps} tipText={errorText} tipType={inputState === inputStateType.inputError ? 'errorTip' : undefined} additionalIcon={inputState === inputStateType.inputWarning ? EmergencyHome : cancel}></ErrorTip>
        </div>
    )
}

export default SelectInput;